import { maintenanceAPI } from './api';

export interface Vehiculo {
    id: string;
    placa: string;
    marca?: string;
    modelo?: string;
    año?: number;
    tipo_operacion?: string;
    empresa_id?: string;
    activo: boolean;
}

export const vehiculoService = {
    async getAll(params?: any) {
        const response = await maintenanceAPI.get('/vehiculos', { params });
        return response.data;
    },

    async getById(id: string) {
        const response = await maintenanceAPI.get(`/vehiculos/${id}`);
        return response.data;
    },

    async getHistorial(id: string) {
        const response = await maintenanceAPI.get(`/vehiculos/${id}/historial`);
        return response.data;
    },
};
